// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"791":"a7b9dea3","874":"43aac025","964":"8545c256"}[chunkId] + ".chunk.js";
};